// extracted by mini-css-extract-plugin
module.exports = {"custom-toggle__link":"CustomToggle_custom-toggle__link__2ESEc","dropdownIcon":"CustomToggle_dropdownIcon__2_wHx"};